import { Outlet } from "react-router-dom";
import { getContentByLocale } from "../../content";
import { useI18n } from "../../i18n";
import { Footer } from "./Footer";
import { Topbar } from "./Topbar";
import { CookieBanner } from "../common/CookieBanner";

export function SiteLayout() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);

  return (
    <main className="site">
      <Topbar items={content.nav} languageLabel={content.languageSwitcherLabel} />
      <Outlet />
      <Footer text={content.footer} />
      <CookieBanner />
    </main>
  );
}
